import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet, useRouter } from '@tanstack/react-router'
import { lazy, Suspense, useEffect } from 'react'
import { callNative, useBridgeEvent } from '@/bridge'
import { Toaster } from '@/components/ui/sonner'

const Devtools = import.meta.env.DEV
  ? lazy(() => import('@/app/devtools').then((m) => ({ default: m.Devtools })))
  : () => null

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: Root,
})

function Root() {
  const router = useRouter()

  // Hide native splash once the first screen has painted.
  useEffect(() => {
    requestAnimationFrame(() => callNative('ready').catch(() => {}))
  }, [])

  // Android hardware back / iOS swipe forwarded by native.
  useBridgeEvent('backPressed', () => {
    if (router.history.canGoBack()) router.history.back()
    else callNative('exit').catch(() => {})
  })

  return (
    <>
      <Outlet />
      <Toaster />
      <Suspense>
        <Devtools />
      </Suspense>
    </>
  )
}
